import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { Box, Button, TextField } from '@mui/material'
import { styled } from '@mui/system'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { decimalPlaces } from '../helpers'

export const TextFieldLots = styled(TextField)(({theme}) => ({
	'.MuiInputBase-input': {
		borderRadius: 4,
		color: theme.palette.text.primary,
		fontSize: 18,
		padding: '12px 12px 12px 16px',
		[theme.breakpoints.down('lg')]: {
			fontSize: 17,
			padding: '11px 11px 11px 15px'
		},
		[theme.breakpoints.down('md')]: {
			fontSize: 16,
			padding: '10px 10px 10px 14px'
		}
	},
	background: theme.palette.second,
	border: 0,
	borderRadius: 4,
	width: '100%'
}))
export const ButtonLots = styled(Button)(({theme}) => ({
	'.MuiButton-startIcon': {
		margin: 0
	},
	background: theme.palette.fourth,
	borderRadius: 2,
	height: 32,
	margin:  '0 4px',
	minWidth: 32,
	padding: 5,
	[theme.breakpoints.down('lg')]: {
		height: 30,
		minWidth: 30
	},
	[theme.breakpoints.down('md')]: {
		height: 28,
		minWidth: 28
	}
}))

const AppNumberField = ({ onGetValue, name, value, maxLotCount, minLotCount }) => {
	const [totalNumber, setTotalNUmber] = useState(value || 1)
	let numberToFixed = decimalPlaces(minLotCount)
	useEffect(() => {
		onGetValue(name, totalNumber)
	}, [totalNumber])

	useEffect(() => {
		if (value !== totalNumber) setTotalNUmber(+value)
	}, [value])

	const getFractionalNumber = (bool) => {
		if (bool) {
			if ((totalNumber + minLotCount) > maxLotCount) {
				return
			}
			if (totalNumber < 1) {
				setTotalNUmber(+(totalNumber + minLotCount).toFixed(numberToFixed))
			} else { setTotalNUmber(totalNumber + 1) }
		} else {
			if ((totalNumber - minLotCount) < minLotCount) {
				return
			}
			if (totalNumber <= 1) {
				setTotalNUmber(+(totalNumber - minLotCount).toFixed(numberToFixed))

			} else { setTotalNUmber(totalNumber - 1) }
		}
	}
	const handleChangeNumberInput = (e) => {
		const value = e.target.value.replace('-', '')
		if (+value < minLotCount) {
			setTotalNUmber(minLotCount)
		} else if (+value > maxLotCount) {
			setTotalNUmber(maxLotCount)
		} else {
			setTotalNUmber(+value)
		}
	}

	return (
		<Box sx={{ position: 'relative' }}>
			<TextFieldLots
				type='number'
				variant='outlined'
				value={totalNumber}
				onChange={handleChangeNumberInput}
				inputProps={{ 'aria-label': 'Without label' }}
				name={name}
			/>
			<Box sx={{
				p: 1,
				position: 'absolute',
				right: 0,
				top: 0
			}}>
				<ButtonLots
					startIcon={<RemoveIcon sx={{ color: '#fff'}} />}
					onClick={() => getFractionalNumber(0)}
					disabled={totalNumber === minLotCount}
				/>
				<ButtonLots
					startIcon={<AddIcon	sx={{	color: '#fff'	}} />}
					onClick={() => getFractionalNumber(1)}
					disabled={totalNumber === maxLotCount}
				/>
			</Box>
		</Box >
	)
}

AppNumberField.propTypes = {
	decimal: PropTypes.bool,
	maxLotCount: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	minLotCount: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number
	]),
	name: PropTypes.string,
	onGetValue: PropTypes.func,
	value: PropTypes.number
}

export default AppNumberField
